import { oidc } from "services/oidcService";

export const zendeskHelper = async channel => {
  if (!window.enableZendeskWidget) {
    window.location.hostname !== "localhost" && console.error("Zendesk module was not loaded");
    return;
  }

  var zendeskWidgetConfig = {
    channel: channel.ID,
    locale: channel.Vendor ? channel.Vendor.Locale.substring(0, 2) : "en",
    clientName: "my-account",

    user: {
      email: await oidc.getCurrentUserEmail(),
      emailReadOnly: false
    },
    zIndex: 18,
    mobileWidthBreakpoint: 576,
    mobileExtraMargin: 6,
    footerElement: document.getElementById("arc3-footer__end-row"),
    contactOptionsEnabled: false
  };

  window.enableZendeskWidget(zendeskWidgetConfig);
};
